import { Box } from "@mui/material";
import clsx from "clsx";
import { useState } from "react";

import CreateProfile from "../../components/CreateProfile";
import Dot from "../Dot";

import { toUSDFormat } from "../../utils/utils";

import useStyles from "./index.styles";

import millify from "millify";
import mapIcon from "../../assets/imgs/map/maps.png";
import config from "../../config/config";
import NativeIcon from "../NativeIcon";

interface LandingHeaderProps {
  playerCount: number;
  familyCount: number;
  vault: number;
  tilesCount: number;
}

const LandingHeader = (props: LandingHeaderProps) => {
  const { classes } = useStyles();
  const [showCreate, setShowCreate] = useState(false);

  const handleShowCreate = () => {
    setShowCreate((showCreate) => !showCreate);
  };

  // const LiveTime = 1742248800;
  // const [curTime, setCurTime] = useState(new Date().getTime() / 1000);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurTime(new Date().getTime() / 1000);
  //   }, 10000);

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, []);

  return (
    <Box className={clsx(classes.body, showCreate ? classes.showCreate : null)}>
      <Box className={classes.arrivalText}>
        A family is awaiting your arrival
      </Box>
      <CreateProfile showCreate={showCreate} setShowCreate={handleShowCreate} />
      <Box className={classes.info}>
        <Box className={classes.infoDetail}>
          <Dot width={10} color="#13d209" isShadow={true} />
          <Box>{toUSDFormat(props.playerCount)} other alive players</Box>
        </Box>
        <Box className={classes.infoDetail}>
          <Dot width={10} color="#d20938" isShadow={true} />
          <Box>{toUSDFormat(props.familyCount)} Crime families</Box>
        </Box>
        <Box className={classes.infoDetail}>
          <Box>Vault</Box>
          <NativeIcon />
          <Box>
            {millify(props.vault, {
              precision: 2,
            })}{" "}
            {config.chainSymbol}
          </Box>
        </Box>
        <Box className={classes.infoDetail}>
          <Box component="img" src={mapIcon} />
          <Box>{toUSDFormat(props.tilesCount)} available tiles</Box>
        </Box>
      </Box>

      {/* <Box className={classes.rankingCountdown}>
        <Box className={classes.rankingBox}>
          <Box>
            <Box component={"img"} src="/assets/imgs/icons/alert.png" />
          </Box>
          <Box>{convertDateTimeWithCooldown(LiveTime - curTime)}</Box>
          <Box>Player ranking starts the 19th March 2025</Box>
        </Box>
      </Box> */}
    </Box>
  );
};

export default LandingHeader;
